// Shared request and rendering safeguards for the cart page and drawer.
var ThemeCartFeedback = {
  fallbackMessage: function () {
    return (window.theme && theme.strings && theme.strings.cartRequestError) ||
      "We couldn't update your basket. Please refresh the page to check it, then try again.";
  },
  errorMessage: function (value) {
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.map(this.errorMessage.bind(this)).filter(Boolean).join(' ');
    if (value && typeof value === 'object') return Object.values(value).map(this.errorMessage.bind(this)).filter(Boolean).join(' ');
    return '';
  },
  request: async function (url, options) {
    var response = await fetch(url, options);
    var state;
    try {
      state = await response.json();
    } catch (error) {
      throw new Error('Invalid cart response');
    }
    if (!state || typeof state !== 'object' || Array.isArray(state)) {
      throw new Error('Invalid cart response');
    }
    if (!response.ok || state.errors || (state.status && Number(state.status) >= 400)) {
      var error = new Error('Cart request failed');
      error.cartMessage = this.errorMessage(state.errors || state.description || state.message);
      throw error;
    }
    return state;
  },
  clearErrors: function (container) {
    container.querySelectorAll('[data-cart-error], .cart-item__error').forEach(function (element) {
      element.hidden = true;
    });
  },
  showError: function (container, error, line) {
    var message = error.cartMessage || this.fallbackMessage();
    var element = line && container.querySelector('#Line-item-error-' + line);
    if (element) {
      element.querySelector('.cart-item__error-text').textContent = message;
    } else {
      element = container.querySelector('[data-cart-error]');
      if (element) element.textContent = message;
    }
    if (element) element.hidden = false;
    publishStandardEvent('CartErrorEvent', standardEventCartError(message));
  },
  restoreQuantity: function (container, key) {
    container.querySelectorAll('input[data-key]').forEach(function (input) {
      if (input.dataset.key === key) input.value = input.defaultValue;
    });
  },
  stageSections: function (definitions, source) {
    if (!source || typeof source !== 'object') throw new Error('Missing cart sections');
    // Validate every replacement before changing any part of the current cart.
    return definitions.map(function (section, index) {
      var target = document.getElementById(section.id);
      if (!target) {
        if (index === 0) throw new Error('Missing cart container');
        return null;
      }
      var html = source[section.section];
      if (typeof html !== 'string' || !html.trim()) throw new Error('Missing cart section');
      var replacement = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (!replacement) throw new Error('Invalid cart section');
      return {
        target: target.querySelector(section.selector) || target,
        html: replacement.innerHTML
      };
    }).filter(Boolean);
  },
  renderSections: function (definitions, source) {
    this.stageSections(definitions, source).forEach(function (replacement) {
      replacement.target.innerHTML = replacement.html;
    });
  }
};
